import QuizSubmissionsLayout from 'components/QuizSubmissions/QuizSubmissionsLayout';

const Mobile = (props) => <QuizSubmissionsLayout device={'mobile'} {...props} />;

export default Mobile;
